import { showMessage } from './store/message-actions';

export default store => (...args) => store.dispatch(showMessage(...args));
